import React, { FC, ReactNode, useRef } from 'react';
import useOutSideClick from '../../hooks/useOutsideClick';

interface OutsideClickProps {
    onClick: () => void;
}

const OutsideClick: FC<OutsideClickProps> = ({ onClick, children }) => {
  const ref = useRef(null);
  useOutSideClick(ref, onClick);

  return (
    <div ref={ref}>
      {children}
    </div>
  )
}

export default OutsideClick;
